module.exports = __webpack_public_path__ + "static/media/Vector.528ef206.svg";